import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiGetNoAuth, ApiPostNoAuth } from "../../ApiSetUp/CommonApi";
import { api, BaseUrl } from "../../ApiSetUp/AuthApi";


//--------------------- master Inventory Apis ------------------------------
export const getRoleManagement = createAsyncThunk(
    "getRoleManagement",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getRoleManagement, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const addRoleManagement = createAsyncThunk(
    "addRoleManagement",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.addRoleManagement, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const updateRoleManagement = createAsyncThunk(
    "updateRoleManagement",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.updateRoleManagement, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getRoleManagementById = createAsyncThunk(
    "getRoleManagementById",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.getRoleManagementById + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const getPermission = createAsyncThunk(
    "getPermission",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.getPermission, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);